import { FetchHelper } from '@/globals/FetchHelper';
import { ShipmentsBody, ShipmentsResponse, TableRowData } from './types';

export class MarketwebTableService {
    private readonly _endpoint;
    private readonly _language;
    private fetchHelper = new FetchHelper('MarketTableService');
    private readonly _getUserShipmentsPath = `/get-user-shipments`;


    constructor(endpoint: string, language: string) {
        this._endpoint = this.formatEndpoint(endpoint);
        this._language = language;
    }

    async getUserShipments(contentId: string, skip: number, take: number, isChatEnabled: boolean): Promise<TableRowData[]> {
        let model: ShipmentsBody =
        {
            skip: skip,
            take: take,
            isChatEnabled: isChatEnabled,
            language: this._language,
            contentId: contentId,
        };

        const fetchUrl = this._endpoint + this._getUserShipmentsPath;

        const data = (await this.fetchHelper.fetchJson(
            fetchUrl,
            this.getRequestInit(model),
            false
        )) as ShipmentsResponse;

        return JSON.parse(data.shipments) as TableRowData[];
    }

    private formatEndpoint(endpoint: string): string {
        var formattedEndpoint = endpoint.lastIndexOf('/') === endpoint.length - 1 ? endpoint.substring(0, endpoint.length - 1) : endpoint;
        return formattedEndpoint;
    }

    private getRequestInit(model: any, method: string = 'POST', mode: RequestMode = 'cors', contentTypes: string = 'application/json'): RequestInit {
        return {
            mode: mode,
            method: method,
            headers:
            {
                'Content-Type': contentTypes
            },
            body: JSON.stringify(model)
        };
    }
}
